import { render, staticRenderFns } from "./LogoBrand.vue?vue&type=template&id=5659e36c&"
import script from "./LogoBrand.vue?vue&type=script&lang=js&"
export * from "./LogoBrand.vue?vue&type=script&lang=js&"
import style0 from "./LogoBrand.vue?vue&type=style&index=0&id=5659e36c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports